import { combineReducers } from "redux";
import App from "./app/reducer";
import Auth from "./auth/reducer";
import EditableTable from "@redux/EditableTable/reducer";
import Company from "@redux/company/reducer";
import Facility from "@redux/facility/reducer";
import Electricity from "@redux/electricity/reducer";
import Water from "@redux/water/reducer";
import Gas from "@redux/gas/reducer";
import WorkOrder from "@redux/workorder/reducer";
import Picklist from "@redux/picklist/reducer";
import SavingFilters from "@redux/SavingFilters/reducer";
import PDF from "@redux/pdf/reducer";
import Project from "@redux/project/reducer";
import Task from "@redux/task/reducer";
import SubTask from "@redux/subtask/reducer";
import Equipment from "@redux/equipment/reducer";
import EquipmentCategory from "@redux/equipmentCategory/reducer";
import FacilityCategory from "@redux/facilityCategory/reducer";
import ProjectComment from "@redux/projectcomment/reducer";
import WorkdorderComment from "@redux/workordercomment/reducer";
import EquipmentComment from "@redux/equipmentcomment/reducer";
import StationTemperature from "@redux/StationTemperature/reducer";
import FacilityBenchmark from "@redux/facilitybenchmark/reducer";
import Scenario from "@redux/Scenario/reducer";
import Notification from "@redux/notification/reducer";
import GlobalData from "@redux/global/reducer";
import GlobalSearch from "@redux/global-search/reducer";

const appReducer = combineReducers({
  App,
  Auth,
  EditableTable,
  WorkOrder,
  Equipment,
  EquipmentCategory,
  FacilityCategory,
  Company,
  Facility,
  Electricity,
  Water,
  Gas,
  SavingFilters,
  Picklist,
  PDF,
  Project,
  Task,
  SubTask,
  ProjectComment,
  WorkdorderComment,
  EquipmentComment,
  FacilityBenchmark,
  StationTemperature,
  Scenario,
  Notification,
  GlobalData,
  GlobalSearch,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
